<template>
  <nav class="navbar is-flex is-align-items-center p-2" role="navigation" aria-label="main navigation">
    <img src="@/assets/IDM.png" width="70" />
    <span class="left-side-line mx-2 is-hidden-mobile"></span>
    <p class="navbar-item is-size-4 has-text-weight-bold has-text-black is-hidden-mobile">
      {{ GetNavName }}
    </p>
    <a href="#" class="ml-auto mr-3 has-text-black" @click="logout">
      <font-awesome-icon
        class="exit-icon"
        :icon="['fas', 'fa-arrow-right-from-bracket']"
      ></font-awesome-icon>
    </a>
<!--    <div-->
<!--      class="navbar-brand"-->
<!--      :class="[ isActive ? '' : 'is-flex is-justify-content-space-between is-align-self-flex-end']"-->
<!--    >-->
<!--      <div class="logo">-->

<!--        <span class="left-side-line"></span>-->
<!--      </div>-->
<!--      &lt;!&ndash; <a  role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample"> &ndash;&gt;-->
<!--      <span class="navbar-burger pt-4" @click="logout">-->
<!--        <font-awesome-icon-->
<!--          class="exit-icon"-->
<!--          :icon="['fas', 'fa-arrow-right-from-bracket']"-->
<!--        ></font-awesome-icon>-->
<!--      </span>-->
<!--    </div>-->
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
  data() {
    return {
      isActive: false,
    }
  },
  computed: mapGetters(["GetNavName", "GetLoginAccess"]),
  methods: {
    ...mapMutations(["SET_USER"]),
    logout() {
      localStorage.removeItem("token")
      this.SET_USER(null)
      window.location.href = "/login"
    },
  },
}
</script>

<style>
.is-hidden {
  display: none;
}

.exit-icon {
  width: 25px;
  height: 25px;
}

.left-side-line {
  height: 40px;
  width: .5px;
  background-color: #b3b3b3;
}
</style>
